import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

export default class ParticipantDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });
    this.state = {
      columns: [
        { title: 'Name', field: 'name', editable: 'never' },
        { title: 'NIK', field: 'nik', type: 'numeric', editable: 'never' },
        { title: 'Ponsel', field: 'phone_number', type: 'numeric', editable: 'never' },
        { title: 'DOB', field: 'date_of_birth', type: 'date', editable: 'never' },
        { title: 'Doctor(1)', field: 'doctor_name', editable: 'never'},
        { title: 'Doctor(2)', field: 'doctor_phase_two_name', editable: 'never'},
        { title: 'Phase 1', field: 'phase_one', type: 'datetime' },
        { title: 'Phase 2', field: 'phase_two', type: 'datetime' },
        { title: 'Batch', field: 'batch_name', editable: 'never' },
        { title: 'Status', field: 'status', lookup: this.props.statuses }
      ],
      data: [],
      page: null,
      totalCount: null
    }

    this.tableRef = React.createRef();
  }

  sendToTeleheal(){
    new Promise((resolve, reject) => {
      const csrfToken = document.querySelector('[name=csrf-token]').content
      {
        return fetch(`/vaccinations/${this.props.vaccination_id}/send_to_teleheal.json`, {
          method: 'POST',
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            'X-CSRF-Token': csrfToken
          }
        }).then(response => {
          return response.json()
        }).then(result => {
          console.log(result)
          alert(result.message)
          // this.tableRef.current && this.tableRef.current.onQueryChange()
          // Turbolinks.visit(result.redirect_url);
        })
      }
      resolve()
      
    });
  }
  downloadCsv(){
    new Promise((resolve, reject) => {
      const csrfToken = document.querySelector('[name=csrf-token]').content
      {
        return fetch(`/vaccinations/${this.props.vaccination_id}/download_csv_file`, {
          method: 'POST',
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            'X-CSRF-Token': csrfToken,
            'Content-Type': 'application/csv',
          }
        }).then(response => {
          return response.blob()
        }).then(blob => {
          // Create blob link to download
          const url = window.URL.createObjectURL(
            new Blob([blob]),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `${new Date().getTime()}.csv`,
          );
          // Append to html link element page
          document.body.appendChild(link);
          // Start download
          link.click();
        })
      }
      resolve()
      
    });
  }

  render () {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title="Peserta Vaksinasi"
          tableRef={this.tableRef}
          columns={this.state.columns}
          data={query =>
            new Promise((resolve, reject) => {
              let url = `/api/vaccinations/${this.props.vaccination_id}/participants.json?`
              // console.log('params', query)
              url += 'per_page=' + query.pageSize
              if (this.props.rescheduled) {
                url += '&rescheduled=true'
              }
              url += '&q=' + query.search
              url += '&page=' + (query.page + 1)
              fetch(url)
                .then(response => response.json())
                .then(result => {
                  // console.log('row data', result.accounts.data)
                  resolve({
                    data: result.participants,
                    page: result.pagination.page - 1,
                    totalCount: result.pagination.count,
                  })
                })
            })
          }
          editable={{
            onRowDelete: oldData =>
              new Promise((resolve, reject) => {
                const csrfToken = document.querySelector('[name=csrf-token]').content
                setTimeout(() => {
                  {
                    return fetch(`/api/vaccination_participants/${oldData.id}`, {
                      method: 'DELETE',
                      headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'X-CSRF-Token': csrfToken
                      }
                    }).then(response => {
                      return response.json()
                    }).then(result => {
                      console.log(result)
                      let data = this.state.data;
                      const index = data.indexOf(oldData);
                      data.splice(index, 1);
                      this.setState({ data }, () => resolve());
                    })
                  }
                  resolve()
                }, 400)
              }),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                const csrfToken = document.querySelector('[name=csrf-token]').content
                // console.log('token is', csrfToken);
                setTimeout(() => {
                  {
                    return fetch(`/api/vaccination_participants/${newData.id}`, {
                      method: 'PUT',
                      body: JSON.stringify(newData),
                      headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        'X-CSRF-Token': csrfToken
                      }
                    }).then(response => {
                      return response.json()
                    }).then(result => {
                      console.log(result)
                      const data = this.state.data;
                      const index = data.indexOf(oldData);
                      data[index] = newData;
                      this.setState({ data }, () => resolve());
                    })
                  }
                  resolve()
                }, 350)
              }),
          }}

          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            },
            // {
            //   icon: 'backup',
            //   tooltip: 'Send to teleheal',
            //   isFreeAction: true,
            //   onClick: (event) => this.sendToTeleheal()
            // },
            // {
            //   icon: 'cloud_download',
            //   tooltip: 'Download Participants CSV',
            //   isFreeAction: true,
            //   onClick: (event) => this.downloadCsv()
            // }
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 100, 200, 300, 500],
            // exportButton: true,
            sorting: true,
            search: true,
            actionsColumnIndex: -1
          }}
          onRowClick={(event, rowData) => Turbolinks.visit(rowData.account_url)}
        />
      </MuiThemeProvider>
    );
  }
}

